<template>
  <div class="data_option" :class="{ option_bar: !optionBar }">
    <template v-if="optionBar">
		<div class="option_top" v-show="optionBar">
      <el-input
        placeholder="请输入查询关键字"
        prefix-icon="el-icon-search"
        size="mini"
        clearable
        v-model="keyword"
      >
      </el-input>
      <el-tabs class="filter-tabs" v-model="activeOptionName" stretch>
        <el-tab-pane label="数据维度" name="dimension" />
        <el-tab-pane label="数据指标" name="field" />
      </el-tabs>
    </div>
    <div class="option_list">
      <el-scrollbar style="height: 100%" class="scrollbar-wapper">
        <el-collapse
          v-model="collapseDimensionList"
          v-show="activeOptionName === 'dimension'"
        >
          <el-collapse-item
            v-for="item in dimensionList"
            :key="item.id"
            :title="item.display_name"
            :name="item.display_name"
          >
            <p
              v-for="child in item.children"
              :key="child.id"
              class="check_name"
            >
              <el-checkbox
                :title="child.display_name"
                :name="child.display_name"
                :value="dimensionCheckIds.includes(child.name)"
                @change="(state) => handleCheckChange(state, 'dimensionCheckList', child)">
                {{ child.display_name }}
              </el-checkbox>
              <template v-if="child.config.title">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="child.config.title"
                  placement="top"
                >
                  <i class="el-icon-question pointer"></i>
                </el-tooltip>
              </template>
              <i
                v-if="showFilterIcon(child)"
                class="el-icon-menu fr pr10 pointer pt6"
                :class="[isConditionActive(child) ? 'text-color-primary' : '']"
                @click.stop="showConditionModal(child)"
              />
            </p>
          </el-collapse-item>
        </el-collapse>
        <el-collapse
          v-model="collapseFieldList"
          v-show="activeOptionName === 'field'"
        >
          <!-- collapseDimensionList -->
          <el-collapse-item
            v-for="item in fieldsList"
            :key="item.id"
            :title="item.display_name"
            :name="item.display_name"
          >
            <div class="check_all">
              <span @click="() =>handleCheckChange(true, 'fieldsCheckList', item.children)">全选</span>
              <span @click=" () => handleCheckChange(false, 'fieldsCheckList', item.children) " >取消全选</span>
            </div>
            <p
              v-for="child in item.children"
              :key="child.id"
              class="check_name"
            >
              <el-checkbox
                :title="child.display_name"
                :name="child.display_name"
                :value="fieldsCheckIds.includes(child.name)"
                @change="
                  (state) => handleCheckChange(state, 'fieldsCheckList', child)
                "
              >
                {{ child.display_name }}
              </el-checkbox>
              <template v-if="child.config.title">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="child.config.title"
                  placement="top"
                >
                  <i class="el-icon-question pointer"></i>
                </el-tooltip>
              </template>
            </p>
          </el-collapse-item>
        </el-collapse>
      </el-scrollbar>
    </div>
    <div v-if="keyword" class="option_list_filter">
      <el-scrollbar style="height: 100%" class="scrollbar-wapper">
        <p v-if="!filterList.hasData" class="no_data">暂无数据</p>
        <div
          class="filter_item"
          v-for="item in filterList.list"
          :key="item.name"
        >
          <div v-show="item.list.length" class="title">{{ item.name }}</div>
          <p v-for="child in item.list" :key="child.id" class="check_name">
            <el-checkbox
              :title="child.display_name"
              :name="child.display_name"
              :value="
                [...dimensionCheckIds, ...fieldsCheckIds].includes(child.name)
              "
              @change="(state) => handleCheckChange(state, item.key, child)"
            >
              {{ child.display_name }}
            </el-checkbox>
            <template v-if="child.config.title">
              <el-tooltip
                class="item"
                effect="dark"
                :content="child.config.title"
                placement="top"
              >
                <i class="el-icon-question pointer"></i>
              </el-tooltip>
            </template>
            <i
              v-if="item.showIcon && showFilterIcon(child)"
              class="el-icon-menu fr pr10 pointer pt6"
              :class="[isConditionActive(child) ? 'text-color-primary' : '']"
              @click.stop="showConditionModal(child)"
            />
          </p>
        </div>
      </el-scrollbar>
    </div>
	</template>
    <div class="option_btn" >
      <div class="option_btn_top" @click="()=>$emit('update:option-bar', !optionBar)">
        <i :class="optionBar ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
      </div>
      <div 
		class="option_btn_bom" 
		:class="{ 'is-fixed': fixedState }" 
		@click="()=>$emit('fixed-change', !fixedState)"
		title="固定：每次查询不会自动收起"
	  >
        <span 
          class="icon iconfont icon-jt-guding1"
          :class="{ 'text-color-primary': fixedState,  }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import {  DIMENSION_NO_FILTER_LIST, DEFAULT_SELECT_MODAL_DATA, DIMENSION_DATE_FORM } from '../../constant'
export default {
	inject: ['conditionModal', 'updataCheck' ],
    props: {
        conditionChecks: {
            type: Array,
            default: ()=>[]
        },
		dimensionList: {
            type: Array,
            default: ()=>[]
        },
        fieldsList: {
            type: Array,
            default: ()=>[]
        },
        dimensionChecks: {
          type: Array,
          default: ()=>[]
        },
        fieldsChecks: {
          type: Array,
          default: ()=>[]
        },
		fixedState: Boolean,
		optionBar: Boolean
    },
    data() {
        return {
          keyword: "",
          activeOptionName: "dimension",
          //维度
          collapseDimensionList: [],
          dimensionCheckList: [],
          // 指标
          collapseFieldList: [],
          fieldsCheckList: [],
        }
    },
    methods: {
        handleCheckChange(check, checkName, data) {
          this.updataCheck(check, checkName, data)
        },
        
        isConditionActive(item){
            return !!this.conditionChecks.find(inner=>inner.name==item.name);
        },
        // 刷选选择
        async showConditionModal(dimension) {
			const condition = { ...dimension };
			const conditionData = this.conditionChecks.find(inner=>inner.name==dimension.name);
			if (conditionData) {
				condition.modalData = { ...conditionData.modalData }
			}else {
				const defaultData = DEFAULT_SELECT_MODAL_DATA[`conditionCheckList_${dimension.name}`];
				if (defaultData) {
					condition.modalData = { ...defaultData }
				}
			}
			this.conditionModal(condition, (data)=> {
				this.handleCheckChange('replace', 'conditionCheckList', cloneDeep({
					...condition,
					modalData: data
				}));
				const dimensionData = cloneDeep(dimension);
				const defaultData = DEFAULT_SELECT_MODAL_DATA[`dimensionCheckList_${dimension.name}`];
				if (defaultData) {
					dimensionData.modalData = cloneDeep(defaultData);
				};
				if (data.dimension) {
					if (!dimensionData.modalData) {
						dimensionData.modalData = {}
					}
					dimensionData.modalData.dimension = data.dimension
				}
				this.handleCheckChange(true, 'dimensionCheckList', dimensionData)
			})
        },
        showFilterIcon(item) {
          return ![].concat(DIMENSION_NO_FILTER_LIST, DIMENSION_DATE_FORM).includes(item.name);
        },
    },
    computed: {
        filterList() {
            const dimensions = this.dimensionList.reduce((pre, item)=> {
                    if (item.children.length) {
                        pre.push(...item.children)
                    }
                    return pre
                }, []).filter(v=> {
                    return (v.display_name || "").toLocaleLowerCase().indexOf(this.keyword.toLocaleLowerCase()) > -1
                })
            const fields = this.fieldsList.reduce((pre, item)=> {
                if (item.children.length) {
                    pre.push(...item.children)
                }
                return pre
            }, []).filter(v=> {
                return (v.display_name || "").toLocaleLowerCase().indexOf(this.keyword.toLocaleLowerCase()) > -1
            });
            return {
                hasData: dimensions.length || fields.length,
                list: [
                    {
                        name: '数据维度',
                        list: dimensions,
                        key: 'dimensionCheckList',
                        showIcon: true 
                    },
                    {
                        name: '数据指标',
                        list: fields,
                        key: 'fieldsCheckList'
                    },
                ]
            }
        },
        dimensionCheckIds() {
          return this.dimensionCheckList.map(v=>v.name)
        },
        fieldsCheckIds() {
          return this.fieldsCheckList.map(v=>v.name)
        },
    },
    watch: {
        fieldsList: {
            handler(n, o) {
                this.collapseFieldList = n.map(v => v.display_name);
            },
            immediate: true
        },
        dimensionList: {
            handler(n, o) {
                 this.collapseDimensionList = n.map(v => v.display_name);
            },
            immediate: true
        },
        fieldsChecks: {
            handler(n, o) {
                this.fieldsCheckList = [ ...n ];
            },
            immediate: true
        },
        dimensionChecks: {
            handler(n, o) {
                this.dimensionCheckList = [ ...n ];
            },
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
.scrollbar-wapper::v-deep .el-scrollbar__wrap{
    overflow-x: hidden !important;
}
.data_option {
  display: flex;
  border: 1px solid #ccc;
  width: calc(100% - 20px);
  padding: 10px 5px;
  flex-direction: column;
  position: relative;
  height: 100%;
  background-color: #fff;
  &.option_bar {
	padding: 0;
  }
  &_bar {
    width: 0;
    padding: 1px;
  }
  .option_top {
    height: 68px;
    &::v-deep .el-tabs__item {
        font-size: 12px !important;
    }
  }
  .option_list {
    flex: 1 1 0;
    overflow: auto;
    .check_all {
        color: #999;
        padding-left: 30px;

        span {
            margin-right: 15px;
            cursor: pointer;
        }
    }
  }
  .filter-tabs {
    margin-top: 8px;
  }

  .check_name {
    padding: 2px 0;
    padding-left: 15px;
  }
  .option_btn {
    position: absolute;
    right: -15px;
    top: 50%;
    transform: translateY(-50%);
    width: 15px;
    &_top {
      height: 50px;
      background: #66b1ff;
      border-radius: 0 4px 4px 0;
      color: #fff;
      font-size: 15px;
      line-height: 50px;
      cursor: pointer;
    }
    &_bom {
      height: 26px;
      
      line-height: 24px;
      margin-top: 15px;
      border-radius: 0 4px 4px 0;
      cursor: pointer;
      border: 1px solid #ccc;
      &.is-fixed {
        border: 1px solid #66b1ff;
      }
      span {
        font-size: 12px;
      }
    }
  }
  ::v-deep .filter-tabs .el-tabs__item {
    font-size: 12px;
    padding: 0 20px !important;
    height: 32px;
    line-height: 32px;
    font-weight: bold;
}

&::v-deep .el-tabs__header {
    margin: 0;
}

&::v-deep .option_list .el-collapse-item__header {
    height: 32px;
    line-height: 32px;
    font-weight: bold;
    font-size: 12px;
}

&::v-deep .option_list .el-collapse-item .el-collapse-item__content {
    padding-bottom: 10px;
}

&::v-deep .option_list .el-collapse-item:last-child .el-collapse-item__wrap {
    border-bottom: none;
}
}

.option_list_filter {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 50px;
    z-index: 3;
    background: #fff;
    &::v-deep .el-scrollbar__wrap {
        overflow-x: hidden;
    }
    .no_data {
        color: #999;
        text-align: center;
    }
    .filter_item {
        .title {
            font-size: 12px;
            color: #000;
            font-weight: bold;
            padding: 0 10px 8px;
        }
        p {
            padding-left: 25px !important;
        }
    }
}
</style>